import * as React from 'react';

interface IProps {
  src: string;
  /* Set to true if the src corresponds to an svg file and the actual svg contents should be rendered.
  If false, the src will be set as the src on an <img> tag  */
  embedInline?: boolean;
  /* Alt or title must be set for functional image/icons. If there is no visible text describing the icon, alt is required */
  alt?: string;
  title?: string;
}

export default function ImageLoader({
  src,
  embedInline,
  alt,
  title,
}: IProps) {
  const [innerHtml, setInnerHtml] = React.useState<string | null>();

  React.useEffect(() => {
    async function fetchImage() {
      const resp = await fetch(src);
      const text = await resp.text();
      setInnerHtml(text);
    }
    if (embedInline) {
      fetchImage();
    }
  }, [src, embedInline]);

  if (!embedInline) {
    return (
      <img src={src} alt={alt} />
    );
  }

  if (!innerHtml) { return null; }

  // if an accessible title is not provided, then the image is decorative, which means aria-hidden="true" should be set
  return (
    <span
      role="img"
      dangerouslySetInnerHTML={{ __html: innerHtml }}
      title={title || undefined}
      aria-hidden={!title ? true : undefined}
    />
  );
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/commons/src/components/image_loader.tsx